import { Component, OnInit } from '@angular/core';
import { ResponsiveScreenService } from '../../services/responsive-screen.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-objective-section',
    templateUrl: './objective-section.component.html',
    styleUrls: ['./objective-section.component.scss'],
    standalone: true,
    imports: [NgIf, TranslateModule]
})
export class ObjectiveSectionComponent {
  constructor(public responsiveScreenService: ResponsiveScreenService) { }
}
